import {
	CaseAndComplaintPublicResponse,
	CasesAndComplaintsPublicResponse,
	CasesPublicResponse,
	CasesResponse,
	ComplaintsPublicResponse,
	ComplaintsResponse,
	DecisionsResponse,
	SearchCaseRequest,
	SearchComplaintRequest,
	SearchContactRequest,
	SearchDecisionRequest,
	SearchUserRequest,
	UsersResponse,
} from '../types/types';
import { HttpResponse, makeRequest } from './index';

const endpoint = 'Search';

export const searchCases = async (
	request: SearchCaseRequest,
	page: number = 1,
	pageSize: number = 10,
	withCounts: boolean = false,
	forStatistics: boolean = false,
): Promise<HttpResponse<CasesResponse>> => {
	const result = await makeRequest<SearchCaseRequest, CasesResponse>(
		`${endpoint}/case?page=${page}&pageSize=${pageSize}&withCounts=${withCounts}&forStatistics=${forStatistics}`,
		request,
		'post',
	);
	return result;
};

export const searchComplaints = async (
	request: SearchComplaintRequest,
	page: number = 1,
	pageSize: number = 10,
	withCounts: boolean = false,
): Promise<HttpResponse<ComplaintsResponse>> => {
	const result = await makeRequest<SearchComplaintRequest, ComplaintsResponse>(
		`${endpoint}/complaint?page=${page}&pageSize=${pageSize}&withCounts=${withCounts}`,
		request,
		'post',
	);
	return result;
};

export const searchUsers = async (request: SearchUserRequest, page: number = 1, pageSize: number = 10): Promise<HttpResponse<UsersResponse>> => {
	const result = await makeRequest<SearchUserRequest, UsersResponse>(`${endpoint}/user?page=${page}&pageSize=${pageSize}`, request, 'post');
	return result;
};

export const searchContacts = async (
	request: SearchContactRequest,
	page: number = 1,
	pageSize: number = 10,
): Promise<HttpResponse<UsersResponse>> => {
	const result = await makeRequest<SearchContactRequest, UsersResponse>(`${endpoint}/contact?page=${page}&pageSize=${pageSize}`, request, 'post');
	return result;
};

export const searchDecisions = async (
	request: SearchDecisionRequest,
	page: number = 1,
	pageSize: number = 10,
	withCounts: boolean = false,
): Promise<HttpResponse<DecisionsResponse>> => {
	const result = await makeRequest<SearchDecisionRequest, DecisionsResponse>(
		`${endpoint}/decision?page=${page}&pageSize=${pageSize}&withCounts=${withCounts}`,
		request,
		'post',
	);
	return result;
};

export const searchPublicCasesAndComplaints = async (
	request: SearchCaseRequest,
	page: number = 1,
	pageSize: number = 10,
): Promise<HttpResponse<CasesAndComplaintsPublicResponse>> => {
	const result = await makeRequest<SearchCaseRequest, CasesAndComplaintsPublicResponse>(
		`${endpoint}/published_case_and_complaint?page=${page}&pageSize=${pageSize}`,
		request,
		'post',
	);
	return result;
};

export const searchPublicComplaints = async (
	request: SearchComplaintRequest,
	page: number = 1,
	pageSize: number = 10,
): Promise<HttpResponse<ComplaintsPublicResponse>> => {
	const result = await makeRequest<SearchComplaintRequest, ComplaintsPublicResponse>(
		`${endpoint}/published_complaint?page=${page}&pageSize=${pageSize}`,
		request,
		'post',
	);
	return result;
};
